import React, { useState, useEffect } from "react";
import "./style.css";
const ViewAnalytics = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Cleanup on unmount
  }, []);

  const iframeWidth = dimensions.width * 0.83; // 80% of screen width
  const iframeHeight = dimensions.height * 0.9; // 90% of screen height

  return (
    <div>
      <iframe
        width={iframeWidth}
        height={iframeHeight}
        src="https://lookerstudio.google.com/embed/reporting/06b51b57-6d6e-4f1a-a81e-574aca51b419/page/p_3e2w8l74pd"
        allowFullScreen
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        title="Analytics Report"
        style={{ border: 0 }}
      ></iframe>
    </div>
  );
};

export default ViewAnalytics;
